import { GISCreditTypes } from './gis';
import { SortItem, sortDirection, sortTypes } from '../ss-api/responses/member.dashboard.license.response';

export interface IGISUsageLogItem  {
    ID: number;
    CreditBundleID: number;
    LicenseKey: string;
    DateTimeCreated: Date;
    CreditType: GISCreditTypes;
    OldCredits: number;
    Address: string;
    Latitude: number;
    Longitude: number;
    Credited: boolean;
    NotCreditedReason: string;
    ParcelBoxInches: number;
    FullSizeImage: boolean;
    DownloadImageParameters: string;

}

export class GISUsageLogItem  implements IGISUsageLogItem {
    ID: number;
    CreditBundleID: number;
    LicenseKey: string;
    DateTimeCreated: Date;
    CreditType: GISCreditTypes;
    OldCredits: number;
    Address: string;
    Latitude: number;
    Longitude: number;
    Credited: boolean;
    NotCreditedReason: string;
    ParcelBoxInches: number;
    FullSizeImage: boolean;
    DownloadImageParameters: string;

}

export class GISUsageLogArray extends Array<GISUsageLogItem>  {
    public LastSort = new SortItem;

    constructor(...items: GISUsageLogItem[]) {
        super(...items);
        Object.setPrototypeOf(this, GISUsageLogArray.prototype);
    }

    public static checkVariables(checkThis: GISUsageLogArray) {
        if ( checkThis.LastSort == undefined ) {
            checkThis.LastSort = new SortItem;
            checkThis.LastSort.SortType = sortTypes.ID;
            checkThis.LastSort.SortDirection = sortDirection.Unsorted;
        }
    }

    public static sortByDate( sortThis: GISUsageLogArray, direction: sortDirection = sortDirection.NotSpecified ): GISUsageLogArray {
        this.checkVariables(sortThis);
        if ( (sortThis.LastSort.SortType == sortTypes.GISUsageDate && direction == sortDirection.NotSpecified && sortThis.LastSort.SortDirection == sortDirection.Ascending) || direction == sortDirection.Descending ) {
            sortThis.sort( (a, b) => {
                if (b.DateTimeCreated < a.DateTimeCreated) return -1;
                else if (b.DateTimeCreated > a.DateTimeCreated) return 1;
                else return 0;
            });
            sortThis.LastSort.SortDirection = sortDirection.Descending;
        } else {
            sortThis.sort( (a, b) => {
                if (a.DateTimeCreated < b.DateTimeCreated) return -1;
                else if (a.DateTimeCreated > b.DateTimeCreated) return 1;
                else return 0;
            });
            sortThis.LastSort.SortDirection = sortDirection.Ascending;
        }
        sortThis.LastSort.SortType = sortTypes.GISUsageDate;
        return sortThis;
    }

}
